export class TicketInfo {
  public pickingRouteId: number = 0
  public workOrderId: number = 0
  public zone: string = ''
  public pickingOrder: string = ''
  public pendingZones: string = ''
  public validationStatusId: number = 0
  public courierDeliveryDate: Date | undefined = undefined
  public courierDeliveryDateString: string = ''
  public workOrderTag: string = ''
  public typePickingRouteId: number = 0
}
